import React from 'react';
import { Container, Col, Row } from "reactstrap"
import { addBodyClasses } from "../utils";
import OnboardingMetaTags from "../../components/OnboardingMetaTags";

const queryString = require('query-string');

function RAFLanding() {
  const parsed = queryString.parse(window.location.search);
  const edition = parsed.edition || 'measure';
  const code = parsed.code || '';
  const name = parsed.name || 'Someone';

  addBodyClasses(['generic-landing-page'])();

  return (
    <Container fluid="sm">
      <OnboardingMetaTags />
      <Row>
        <Col>
          <h1>{name} thinks you will enjoy the MSR app!</h1>
          <p>By joining your friend, you'll both earn more. Let’s get started.</p>
          <img
            className="splash-image"
            alt="Have fun with MSR!"
            src="/img/landing-splash-woman.png"
            srcSet="/img/landing-splash-woman@2x.png 2x, /img/landing-splash-woman@3x.png 3x"
          />
          <div className="action-button">
            <a className="btn btn-primary" href={`/sign-up?edition=${edition}&code=${code}`}>Claim bonus</a>
          </div>
          <p className="landing-terms">Subject to MSR's <a href="/terms">Terms and Conditions</a></p>
        </Col>
      </Row>
    </Container>
  );
}

export default RAFLanding;
